import { useEffect } from "react";
import "./app.css";
import "./custom.css";

export default () => {
    const data = [
        { link: "https://order.tabin.co.nz/57b07a45-47cc-42a4-943d-4748f7dc2663", name: "Commercial Bay", available: true },
        // { link: "https://order.tabin.co.nz/e95fcd98-f499-4a2a-87bd-e0a3e0cf7370", name: "Grey Lynn", available: true },
    ];

    const onOrder = (link) => {
        window.location.href = `${link}`;
    };

    return (
        <>
            <div className="restaurant-list">
                <img
                    src={`https://d1hfsnuz4i23pd.cloudfront.net/public/2025-10-07_03:45:23.255-2022-04-10_08_33_28.webp`}
                    className="restaurant-list-logo"
                    alt="logo"
                />
                <div className="h3 text-center mb-6">Select a location you would like to order from:</div>
                {data &&
                    data.map((restaurant, index) => (
                        <div key={restaurant.link}>
                            {index != 0 && <div className="separator-4"></div>}
                            <div className="restaurant-list-item">
                                <div className="restaurant-name">{restaurant.name}</div>
                                <button
                                    className={`button ${restaurant.available ? "" : "disabled"}`}
                                    onClick={() => {
                                        restaurant.available && onOrder(restaurant.link);
                                    }}
                                >
                                    {restaurant.available ? "Order Here" : "Unavailable"}
                                </button>
                            </div>
                        </div>
                    ))}
            </div>
        </>
    );
};
